import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const CTA = () => {
    return (
        <section className="py-32 px-6 max-w-7xl mx-auto relative overflow-hidden bg-[#0a0a0a]">
            {/* Background Glows */}
            <div className="absolute top-0 left-1/4 w-[400px] h-[400px] bg-blue-600/10 blur-[120px] rounded-full -translate-y-1/2"></div>
            <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-blue-600/5 blur-[120px] rounded-full translate-y-1/2"></div>

            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="relative z-10 bg-white/[0.02] backdrop-blur-3xl p-16 md:p-24 rounded-[3rem] border border-white/5 overflow-hidden group shadow-2xl"
            >
                {/* Tech Accents */}
                <div className="absolute top-0 left-0 w-20 h-20 border-t border-l border-blue-500/20 rounded-tl-[3rem] group-hover:border-blue-500/40 transition-colors duration-500"></div>
                <div className="absolute bottom-0 right-0 w-20 h-20 border-b border-r border-blue-500/20 rounded-br-[3rem] group-hover:border-blue-500/40 transition-colors duration-500"></div>

                <div className="max-w-3xl mx-auto text-center relative z-10">
                    <div className="inline-block px-6 py-2 rounded-full bg-blue-600/10 border border-blue-500/20 mb-8">
                        <span className="text-blue-400 font-black text-[10px] uppercase tracking-[0.3em]">Grade 11 Intake 2026</span>
                    </div>

                    <h2 className="text-3xl md:text-6xl font-black leading-[0.95] text-white tracking-tighter mb-10 uppercase">
                        READY TO UNLOCK <br />
                        <span className="text-blue-500">YOUR "A" GRADE?</span>
                    </h2>

                    <p className="text-base md:text-lg text-white/40 mb-14 max-w-xl mx-auto font-medium leading-relaxed group-hover:text-white/60 transition-colors">
                        Join <span className="text-white font-bold">10,000+</span> O/L students who mastered the logic of mathematics and transformed their academic futures.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
                        <Link to="/login" className="w-full sm:w-auto">
                            <motion.button
                                whileHover={{ scale: 1.05, y: -2 }}
                                whileTap={{ scale: 0.98 }}
                                className="w-full sm:w-auto px-12 py-6 bg-blue-600 text-white font-black text-xs rounded-2xl shadow-[0_15px_30px_-10px_rgba(37,99,235,0.4)] hover:bg-blue-700 transition-all uppercase tracking-[0.2em]"
                            >
                                Secure Your Slot
                            </motion.button>
                        </Link>
                        <motion.button
                            whileHover={{ scale: 1.05, bg: "rgba(255,255,255,0.05)" }}
                            whileTap={{ scale: 0.98 }}
                            className="w-full sm:w-auto px-12 py-6 bg-transparent border border-white/10 text-white font-black text-xs rounded-2xl hover:border-blue-500/30 transition-all uppercase tracking-[0.2em]"
                        >
                            Request Trial
                        </motion.button>
                    </div>
                </div>

                {/* Inner Decorative Line */}
                <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-blue-500/20 to-transparent"></div>
            </motion.div>
        </section>
    );
};

export default CTA;
